import React, { useRef } from "react";
import Image from "next/image";
import styles from "../../styles/shap_of_you.module.scss";
import WelcomeScreenImg from "../../assets/images/WelcomeScreen.png";
import SOYLockUp from "../../assets/images/SOYLockUp.png";
import { UploadOrScanScreenProps } from "./types";

const UploadOrScanScreen: React.FC<UploadOrScanScreenProps> = ({
  navigateToStep,
  onImageSelect,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Handle file selection (same as GalleryPermissionScreen)
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        if (onImageSelect) {
          onImageSelect(base64String);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle upload button click - check localStorage first
  const handleUploadClick = () => {
    const galleryPermission = localStorage.getItem("galleryPermissionGranted");

    if (galleryPermission === "true") {
      // Permission already granted - directly trigger file input
      fileInputRef.current?.click();
    } else {
      // Permission not granted - navigate to permission screen
      navigateToStep("galleryPermission");
    }
  };
  return (
    <div className="d-md-none w-100">
      <div className={styles.mobile_view_shap_welcome_one}>
        <div className={styles.bgImage}>
          <Image src={WelcomeScreenImg} alt="Welcome Screen" />
        </div>
        <div className={styles.shapeOfYou}>
          <div className={styles.content}>
            <div className={styles.title}>
              <Image src={SOYLockUp} alt="Shape of You Logo" />
            </div>
            {/* Hidden file input */}
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />

            <button
              className={styles.ctaBtn}
              onClick={handleUploadClick}
            >
              Upload your Image{" "}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 8H15.01"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.5 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V12.5"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 16.0001L8 11.0001C8.928 10.1071 10.072 10.1071 11 11.0001L14.5 14.5001"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14 13.9999L15 12.9999C15.679 12.3469 16.473 12.1709 17.214 12.4739"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 22V16"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 19L19 16L16 19"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <p className={styles.or}>OR</p>
            <button
              className={styles.ctaBtn}
              onClick={() => navigateToStep("cameraPermission")}
            >
              Scan Face{" "}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 3H5C3.89543 3 3 3.89543 3 5V7"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17 3H19C20.1046 3 21 3.89543 21 5V7"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15 9V11"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 9V11"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 15C9 15 10 16 12 16C14 16 15 15 15 15"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7 21H5C3.89543 21 3 20.1046 3 19V17"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17 21H19C20.1046 21 21 20.1046 21 19V17"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadOrScanScreen;
